import React from "react";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import { DASHBOARD_REPORT_LINKS_DISABLED } from "../../constants/dashboardVisualConfig";

type SectionCardProps = {  title?: string;
  subtitle?: string;
  className?: string;
  headerExtra?: React.ReactNode;
  children: React.ReactNode;
  dark?: boolean;
};

const SectionCard: React.FC<SectionCardProps> = ({
  title,
  subtitle,
  className = "",
  headerExtra,
  children,
  dark = false,
}) => {
  return (
    <div
      className={`admin-home-card${dark ? " admin-home-card--dark" : ""} ${className}`.trim()}
    >
      {(title || headerExtra) && (
        <div className="admin-home-card__header">
          <div className="admin-home-card__header-text">
            {title && <h3 className="admin-home-card__title">{title}</h3>}
            {subtitle && (
              <p className="admin-home-card__subtitle">{subtitle}</p>
            )}
          </div>
          {headerExtra}
        </div>
      )}
      <div className="admin-home-card__body">{children}</div>
    </div>
  );
};

type ReportLinkProps = {
  label: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
};

export const ReportLink: React.FC<ReportLinkProps> = ({
  label,
  onClick,
  className = "",
  disabled = DASHBOARD_REPORT_LINKS_DISABLED,
}) => (
  <button
    type="button"
    className={`admin-home-report-link${
      disabled ? " admin-home-report-link--disabled" : ""
    } ${className}`.trim()}
    onClick={disabled ? undefined : onClick}
    disabled={disabled}
  >
    {label}
    <Iconography icon="arrowRight" size={IconographySizes.Small} />
  </button>
);
export default SectionCard;
